import { HistoryManager } from "./history-manager";

export const useHistoryManager = () => {
  return HistoryManager.instance;
};
